import { render, staticRenderFns } from "./NotificationsFeed.vue?vue&type=template&id=e343bf68"
import script from "./NotificationsFeed.vue?vue&type=script&lang=js"
export * from "./NotificationsFeed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports